import styled, { ThemeProps } from 'styled-components';
import { Theme } from '../theme';
import { font, media } from '../theme/base/mixins';
import { StyledDivComponent, StyledInputComponent } from '../types';
import { ButtonAnchor } from './Button';
import { FontIconSpan } from './FontIcon';
import { Section } from './Section';
import { rgba } from './utils/rgba';

// explicity set font-size, line-height, font-weight

export const IntroSearchBar: StyledDivComponent = styled.div`
  top: 0;
  position: relative;
  width: 100%;
  height: 69px;
  margin-bottom: -69px;
  background-color: ${(props: ThemeProps<Theme>) =>
    rgba(props.theme.colors.white, 0.9)};
  z-index: 100;

  ${Section} {
    padding: 0;
    height: 100%;
  }
`;

interface InputContainerProps {
  focus?: boolean;
}

type InputContainerPropsThemed = ThemeProps<Theme> & InputContainerProps;

export const InputContainer: StyledDivComponent<
  InputContainerProps
> = styled.div`
  margin: 2px 0;
  padding: 9px 40px 11px;
  position: relative;
  transition: background-color 0.5s;
  background-color: ${({ focus }: InputContainerPropsThemed) =>
    focus ? props => props.theme.colors.white : 'transparent'};
`;

export const ResultsContainer = styled.div`
  max-height: 300px;
  overflow: auto;
  position: relative;
`;

export const ResultsScrollView = styled.div``;

export const ResultType: StyledDivComponent = styled.div`
  height: 40px;
  background-color: rgba(222, 222, 222, 0.2);
  width: 100%;
  padding: 6px 10px;

  ${font(2, 2.9, 'normal')};

  span {
    font-family: ${({ theme }: ThemeProps<Theme>) => theme.defaults.fontFamily};

    height: 28px;
    width: 100%;
    color: ${(props: ThemeProps<Theme>) => props.theme.colors.gray};
  }
`;

interface ResultProps {
  active?: boolean;
}

type ResultPropsThemed = ThemeProps<Theme> & ResultProps;

export const Result: StyledDivComponent<ResultProps> = ResultType.extend`
  height: 50px;
  background-color: ${({ active }: ResultPropsThemed) =>
    active ? '#EA5B0C' : 'transparent'};
  padding: 10px;
  border-bottom: 1px solid
    ${(props: ResultPropsThemed) => rgba(props.theme.colors.grayMedium, 0.2)};
  cursor: pointer;

  span {
    color: ${({ active, theme }: ResultPropsThemed) =>
      active ? theme.colors.white : theme.colors.stickyBg};
  }

  &:hover {
    background-color: #ea5b0c;

    span {
      color: #fff;
    }
  }
`;

export const Results = styled.div``;

export const Input: StyledInputComponent = styled.input.attrs({
  type: 'text'
})`
  font-family: ${({ theme }: ThemeProps<Theme>) => theme.defaults.fontFamily};
  ${font(2.2, 2.5, 'normal')};

  height: 45px;
  width: 100%;
  padding: 12px 50px 11px 10px;
  border: none;
  border-bottom: 1px solid
    ${(props: ThemeProps<Theme>) => rgba(props.theme.colors.grayMedium, 0.5)};
  outline: none;
  background-color: transparent;
  display: block;
  color: ${(props: ThemeProps<Theme>) => props.theme.colors.stickyBg};
`;

export const SearchLink = ButtonAnchor.extend`
  position: absolute;
  right: 0;
  top: 0;
  box-shadow: none;
  padding: 13px 12px 12px !important;
  width: auto;

  ${media.large`
    right: 40px;
    top: 11px;
    padding: 11px 10px 9px !important;
  `}

  ${FontIconSpan} {
    position: relative;
    top: 0;
    color: ${(props: ThemeProps<Theme>) => props.theme.colors.white};

    &:before {
      margin: 0;
    }
  }
`;
